<template>
  <div class="page-container content-430">
    <div class="header-wrapper-430">
      <Form
        ref="searchForm"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">
          <FormItem label="">
            <Select
              v-model="searchConds.orgId"
              class="search-select-430"
              placeholder="请选择服务"
            >
              <Option
                v-for="(item, index) in orgList"
                :key="index"
                :value="item.orgId"
              >{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="">
            <Input
              v-model="searchConds.teacherName"
              placeholder="教师姓名"
              clearable
              class="search-input-430"
            ></Input>
          </FormItem>
          <FormItem label="">
            <Input
              v-model="searchConds.teacherPhone"
              placeholder="请输入手机号码"
              clearable
              class="search-input-430"
            ></Input>
          </FormItem>
          <Button type="primary" @click="handleSearch">确定</Button>
          <Button class="search-430" @click="handleReset">重置</Button>
        </Row>
      </Form>
    </div>

    <div class="flex justify-content_end">
      <div class="top-operate" style="padding: 16px 0">
        <Button
          type="primary"
          class="op-btn"
          @click="exportHandel"
        >导出</Button>
      </div>
    </div>
    <div class="main-wrapper">
      <div class="table">
        <Table
          ref="selection"
          border
          :columns="tableColumns"
          :data="tableData"
          :max-height="tableHeight"
        >
          <template slot="gender" slot-scope="{ row, index }">
            {{ row.gender == '1' ? '女' : '男' }}
          </template>
          <template slot="teacherType" slot-scope="{ row, index }">
            {{ row.teacherType == '1' ? '班主任' : '普通老师' }}
          </template>
        </Table>
      </div>
      <div class="paging">
        <Page
          :current="page.pageNum"
          :total="page.total"
          show-total
          show-elevator
          @on-change="pageChange"
        ></Page>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { filterParams, downloadReport } from '@/utils/utils';
import schoolAdmin from '@/request/schoolAdmin/index.js';
import EditButton from '@/pages/assetsModules/EditButton';
import mixinTableHeight from '@/mixins/mixinTableHeight';
import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle';
export default {
  name: 'SchoolResourcesTeacher2',
  components: { EditButton },
  mixins: [mixinTableHeight],
  data() {
    return {
      allCity: [],
      showAllSearch: false,
      schoolId: '',
      searchConds: {
        orgId: '',
        teacherName: '',
        teacherPhone: ''
      },
      page: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      tableColumns: [
        key(null, null, tableColumnsWidth.type1, {
          type: 'selection',
          fixed: 'left'
        }),
        key('账号', 'userId', tableColumnsWidth.type4,),
        key('姓名', 'teacherName', tableColumnsWidth.type3),
        slot('性别', 'gender', tableColumnsWidth.type2),
        slot('角色', 'teacherType', tableColumnsWidth.type2),
        key('手机号码', 'teacherPhone', tableColumnsWidth.type3),
        key('所属服务', 'schoolName', tableColumnsWidth.type5,),
        key('工号', 'teacherNo', tableColumnsWidth.type4,),
        key('更新时间', 'createTime', tableColumnsWidth.type3)
      ],
      tableData: [],
      orgList: []
    };
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['routeTitle'])
  },
  created() {
    this.init();
    this.getassociatedOrgFunc();
    this.getTeacherQueryListByOrnFunc();
  },
  mounted() { },
  methods: {
    init() {
      this.schoolId = this.userInfo.orgId;
      console.log(this.userInfo);
    },
    handleDispatchDatePick() { },
    handleReset() {
      this.searchConds.teacherName = '';
      this.searchConds.teacherPhone = '';
      this.searchConds.orgId = '';
      this.getTeacherQueryListByOrnFunc();
    },
    handleSearch() {
      this.getTeacherQueryListByOrnFunc();
    },
    // 翻页
    pageChange(current) {
      this.page.pageNum = current;
      this.getTeacherQueryListByOrnFunc();
    },
    // 导出
    async exportHandel() {
      const data = {
        schoolId: this.schoolId,
        teacherName: this.searchConds.teacherName,
        orgId: this.searchConds.orgId,
        teacherPhone: this.searchConds.teacherPhone
      };
      const params = filterParams(data);
      const url = `${process.env.VUE_APP_API_BASESTORE_URL}/teacher/export/org`;
      downloadReport(url, params);
    },
    // ?  =====接口======
    // 获取列表
    async getTeacherQueryListByOrnFunc() {
      const params = {
        schoolId: this.schoolId,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        teacherName: this.searchConds.teacherName,
        orgId: this.searchConds.orgId
      };
      if (this.searchConds.teacherPhone) {
        params['teacherPhone'] = this.searchConds.teacherPhone;
      }
      const res = await this.$http.getTeacherQueryListByOrn(params);
      if (res.status == 200) {
        this.page.total = Number(res.message.total);
        this.tableData = res.message.list;
      }
    },
    // 获取学校已关联的服务
    async getassociatedOrgFunc() {
      const params = {
        schoolId: this.schoolId,
        pageSize: 100
      };
      const res = await schoolAdmin.getSchoolOrgList(params);
      if (res.status === 200) {
        this.orgList = res.message.list;
        const obj = {
          orgId: '',
          orgName: '请选择'
        };
        this.orgList.unshift(obj);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common';
.page-container {
  height: 100%;
  .flex-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left-action {
      display: flex;
      .li {
        margin-right: 30px;
        display: flex;
        align-items: center;
        .label {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.passwordModal-main {
  width: 100%;
  .form-ul {
    width: 100%;
    .form-li {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .label {
        font-size: 14px;
        width: 120px;
        text-align: right;
        span {
          color: red;
        }
      }
    }
  }
  .form-btn {
    padding-top: 100px;
    padding-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
